/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Col_DestinationInputs */

const en_po_col_destination = /** @type {(inputs: Po_Col_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destination`)
};

/**
* | output |
* | --- |
* | "Destination" |
*
* @param {Po_Col_DestinationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_col_destination = /** @type {((inputs?: Po_Col_DestinationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Col_DestinationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_col_destination(inputs)
});